import React from "react";

function NewZealandFlag() {
  return (
    <div>
      <svg
        className="icon-sm"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 473.684 473.684"
        style={{ width: "40px", height: "40px" }}
        space="preserve"
      >
        <path
          style={{ fill: "#252F6B" }}
          d="M236.835,0v473.677c130.807,0,236.842-106.036,236.842-236.835C473.677,106.028,367.641,0,236.835,0z
	"
        />
        <path
          style={{ fill: "#273375" }}
          d="M236.835,0C106.036,0,0,106.032,0,236.838c0,130.799,106.036,236.835,236.835,236.835
	C367.641,473.673,367.641,0,236.835,0z"
        />
        <polygon
          style={{ fill: "#ff0000" }}
          points="351.206,380.644 360.263,369.361 346.277,371.893 341.427,358.352 336.154,371.893 
		321.88,369.361 330.952,380.389 321.536,391.417 335.889,389.159 340.731,402.416 346.004,389.166 360.648,391.784 	"
        />
        <polygon
          style={{ fill: "#ff0000" }}
          points="351.206,131.338 360.263,120.052 346.277,122.587 341.427,109.046 336.154,122.587 
		321.88,120.052 330.952,131.087 321.536,142.108 335.889,139.853 340.731,153.117 346.004,139.86 360.648,142.474 	"
        />
        <polygon
          style={{ fill: "#ff0000" }}
          points="409.797,195.83 418.847,184.544 404.869,187.08 400.018,173.539 394.746,187.08 
		380.464,184.544 389.536,195.58 380.12,206.604 394.473,204.345 399.315,217.61 404.588,204.353 419.232,206.967 	"
        />
        <polygon
          style={{ fill: "#ff0000" }}
          points="300.523,224.502 309.581,213.219 295.595,215.755 290.744,202.214 285.472,215.755 
		271.201,213.219 280.27,224.247 270.857,235.275 285.21,233.02 290.053,246.273 295.325,233.028 309.97,235.642 	"
        />

        <path
          style={{ fill: "#29337A" }}
          d="M49.74,91.713c-3.717,4.79-7.266,9.708-10.62,14.775h25.388L49.74,91.713z"
        />
        <polygon
          style={{ fill: "#29337A" }}
          points="172.043,236.838 194.858,236.838 172.043,214.023 	"
        />
        <path
          style={{ fill: "#29337A" }}
          d="M96.417,46.135c-5.434,4.009-10.665,8.261-15.732,12.707l15.732,15.725V46.135z"
        />
        <polygon
          style={{ fill: "#29337A" }}
          points="73.595,236.838 96.417,236.838 96.417,214.016 	"
        />
        <path
          style={{ fill: "#29337A" }}
          d="M236.835,0c-22.475,0-44.187,3.197-64.792,9.05v65.517l64.799-64.796V0H236.835z"
        />
        <polygon
          style={{ fill: "#29337A" }}
          points="236.842,215.003 236.842,182.121 203.96,182.121 	"
        />
        <path
          style={{ fill: "#29337A" }}
          d="M9.772,236.838L64.5,182.121H6.428C2.266,199.693,0,217.998,0,236.838H9.772z"
        />
        <polygon
          style={{ fill: "#29337A" }}
          points="203.938,106.488 236.842,106.488 236.842,73.591 	"
        />

        <polygon
          style={{ fill: "#FFFFFF" }}
          points="236.842,221.91 236.842,215.003 203.96,182.121 236.842,182.121 236.842,170.345 
		185.277,170.345 	"
        />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M64.508,106.488H39.12c-2.535,3.841-4.944,7.771-7.259,11.765h49.875L52.133,88.658
		c-0.811,1.01-1.608,2.031-2.397,3.051L64.508,106.488z"
        />
        <polygon
          style={{ fill: "#FFFFFF" }}
          points="96.417,214.016 96.417,236.838 108.186,236.838 108.186,196.788 68.139,236.838 
		73.595,236.838 	"
        />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M172.043,9.046c-3.968,1.126-7.887,2.352-11.765,3.672v79.077l76.564-76.56V9.779l-64.799,64.784
		V9.046z"
        />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M96.002,182.121l0.415-0.415l0,0l11.357-11.357H9.532c-1.133,3.885-2.169,7.808-3.104,11.772H64.5
		L9.772,236.838h31.51L96.002,182.121L96.002,182.121z"
        />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M9.772,236.838L64.5,182.121L9.772,236.838z"
        />
        <polygon
          style={{ fill: "#FFFFFF" }}
          points="236.842,118.257 236.842,106.488 203.938,106.488 236.842,73.591 236.842,42.089 
		160.671,118.257 	"
        />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M236.842,73.591l-32.905,32.897L236.842,73.591z"
        />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M96.417,74.571L80.685,58.846c-5.579,4.903-10.935,10.063-16.032,15.471l31.764,31.764l0,0
		l0.337,0.344l11.432,11.432V38.028c-4.001,2.599-7.939,5.28-11.765,8.107v28.436H96.417z"
        />
        <polygon
          style={{ fill: "#FFFFFF" }}
          points="172.043,214.023 194.858,236.838 224.917,236.838 160.274,172.2 160.274,236.838 
		172.043,236.838 	"
        />

        <path
          style={{ fill: "#D32030" }}
          d="M96.417,106.081l0.337,0.344L96.417,106.081z"
        />
        <path
          style={{ fill: "#D32030" }}
          d="M197.042,182.121l-11.765-11.772h51.565v-52.092h-76.171l-0.393,0.4v-0.4h0.393l76.171-76.164
		V15.235l-76.568,76.564V12.722c-18.507,6.324-35.971,14.857-52.092,25.309v79.825l0.408,0.4h-0.408v-0.4L96.75,106.425l0.067,0.067
		h-0.4v-0.408L64.653,74.32c-4.36,4.615-8.537,9.394-12.52,14.345l29.602,29.595H31.861c-9.424,16.245-16.959,33.701-22.329,52.092
		h98.242l0.408-0.415v0.415h-0.408L96.417,181.71v0.415h-0.415l-54.721,54.714h26.858l40.047-40.051v40.051h52.092V172.2
		l64.639,64.639h8.889c1.013-1.058,2.046-2.109,3.04-3.197V221.91L197.042,182.121z"
        />
        <polygon
          style={{ fill: "#D32030" }}
          points="160.274,91.799 236.842,15.235 236.842,15.235 	"
        />
        <polygon
          style={{ fill: "#D32030" }}
          points="96.417,182.121 96.417,181.702 96.002,182.121 	"
        />
        <polygon
          style={{ fill: "#D32030" }}
          points="108.186,169.93 107.775,170.345 108.186,170.345 	"
        />
        <polygon
          style={{ fill: "#D32030" }}
          points="160.274,118.657 160.671,118.257 160.274,118.257 	"
        />
        <polygon
          style={{ fill: "#D32030" }}
          points="96.417,106.488 96.821,106.488 96.754,106.425 96.417,106.081 	"
        />
        <polygon
          style={{ fill: "#D32030" }}
          points="108.593,118.257 108.186,117.853 108.186,118.257 	"
        />
      </svg>
    </div>
  );
}
export default NewZealandFlag;
